function removeCookeNotice() {
    const cookieNotice = document.querySelector('.js-cookie-notice');
    cookieNotice.parentNode.removeChild(cookieNotice);

    const cookieNoticeOverlay = document.querySelector('.js-cookie-notice-overlay');
    cookieNoticeOverlay.parentNode.removeChild(cookieNoticeOverlay);
}

if (docCookies.getItem('acceptCookies')) {
    removeCookeNotice();
}

if (document.querySelector('.js-accept-cookie')) {
    document.querySelector('.js-accept-cookie').addEventListener('click', () => {
        docCookies.setItem('acceptCookies', true, 31536e3);
        removeCookeNotice();
    });
}
